/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Profile_LabelInputs */

const en_subtitle_export_profile_label = /** @type {(inputs: Subtitle_Export_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile`)
};

const fr_subtitle_export_profile_label = /** @type {(inputs: Subtitle_Export_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const de_subtitle_export_profile_label = /** @type {(inputs: Subtitle_Export_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const it_subtitle_export_profile_label = /** @type {(inputs: Subtitle_Export_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profilo`)
};

const ru_subtitle_export_profile_label = /** @type {(inputs: Subtitle_Export_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Профиль`)
};

const es_subtitle_export_profile_label = /** @type {(inputs: Subtitle_Export_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil`)
};

const zh_cn2_subtitle_export_profile_label = /** @type {(inputs: Subtitle_Export_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`轮廓`)
};

const ja_subtitle_export_profile_label = /** @type {(inputs: Subtitle_Export_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロフィール`)
};

const hi_subtitle_export_profile_label = /** @type {(inputs: Subtitle_Export_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोफ़ाइल`)
};

const pt_pt2_subtitle_export_profile_label = /** @type {(inputs: Subtitle_Export_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil`)
};

/**
* | output |
* | --- |
* | "Profile" |
*
* @param {Subtitle_Export_Profile_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_profile_label = /** @type {((inputs?: Subtitle_Export_Profile_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Profile_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_profile_label(inputs)
	if (locale === "de") return de_subtitle_export_profile_label(inputs)
	if (locale === "it") return it_subtitle_export_profile_label(inputs)
	if (locale === "ru") return ru_subtitle_export_profile_label(inputs)
	if (locale === "es") return es_subtitle_export_profile_label(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_profile_label(inputs)
	if (locale === "ja") return ja_subtitle_export_profile_label(inputs)
	if (locale === "hi") return hi_subtitle_export_profile_label(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_profile_label(inputs)
	return en_subtitle_export_profile_label(inputs)
});